<template>
  <div class="delivery-store">
    <el-form
      ref="form"
      :model="formData"
      label-position="top"
      class="delivery-form"
    >
      <div class="delivery-columns">
        <section class="entry-card">
          <h3 class="panel-title">
            <span class="panel-dot" />门店自提 <small>STORE-PICKUP</small>
          </h3>
          <el-form-item label="设备串号" prop="serialNo" :rules="rules">
            <el-input
              class="serial-no-input"
              v-model="formData.serialNo"
              size="small"
              placeholder="请输入设备串号"
              @keydown.native="
                ($event.key === ' ' || $event.code === 'Space') &&
                $event.preventDefault()
              "
            />
          </el-form-item>
          <el-form-item
            label="签收证明上传"
            prop="receiveImageList"
            :rules="rules"
          >
            <FileUpload :isMulti="true" :name.sync="formData.receiveImageList">
              <div class="upload-placeholder">
                <i class="el-icon-circle-plus-outline" /><span>签收证明</span>
              </div>
            </FileUpload>
          </el-form-item>
          <div class="auxiliary-heading">辅助材料 <small>选填</small></div>
          <div class="auxiliary-uploads">
            <el-form-item prop="holdingReceiveImage">
              <FileUpload
                single-preview-delete
                :name.sync="formData.holdingReceiveImage"
              >
                <div class="upload-placeholder">
                  <i class="el-icon-circle-plus-outline" /><span
                    >手持身份证和手机照片</span
                  >
                </div>
              </FileUpload>
            </el-form-item>
            <el-form-item prop="incomeImage">
              <FileUpload
                single-preview-delete
                :name.sync="formData.incomeImage"
              >
                <div class="upload-placeholder">
                  <i class="el-icon-circle-plus-outline" /><span>收入证明</span>
                </div>
              </FileUpload>
            </el-form-item>
          </div>
          <p class="upload-tip">
            ★
            建议尽量上传：本人手持身份证与手机的同框照片，确保人脸、证件信息清晰完整、无遮挡；收入证明可上传工资流水、在职证明、兼职收入记录等。
          </p>
          <div class="choice-columns">
            <el-form-item>
              <span slot="label">服务区位异常 <small>选填</small></span>
              <el-radio-group
                v-model="formData.serviceAreaTagCode"
                class="tag-option"
              >
                <el-radio-button
                  v-for="tag in serviceAreaTagList.children"
                  :key="tag.tagCode"
                  :label="tag.tagCode"
                  @click.native.prevent="
                    handleServiceAreaTagToggle(tag.tagCode)
                  "
                  >{{ tag.tagName }}</el-radio-button
                >
              </el-radio-group>
            </el-form-item>
            <el-form-item label="监管锁" required>
              <el-radio-group v-model="formData.lockType" class="tag-option">
                <el-radio-button label="zhunfu5">准富5.0</el-radio-button>
                <el-radio-button label="zhunfu2">准富2.0</el-radio-button>
                <el-radio-button label="wangsha">网沙监管锁</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </div>
          <el-form-item class="remark-field"
            ><span slot="label">备注 <small>选填</small></span
            ><el-input
              type="textarea"
              :rows="3"
              v-model="formData.remark"
              size="small"
              placeholder="请输入发货备注"
          /></el-form-item>
        </section>
        <section class="settlement-card">
          <header class="settlement-header">
            <div class="settlement-overview">
            <h3 class="panel-title"><span class="panel-dot" />门店结算明细</h3>
            <div class="settlement-store">
              <strong>{{
                storeSettlementInformation.store
                  ? storeSettlementInformation.store.storeName
                  : "-"
              }}</strong
              ><el-tag class="settlement-type-tag" type="warning" effect="dark">{{
                storeSettlementInformation.settleTypeName || "-"
              }}</el-tag>
            </div>
            </div>
            <div
              v-if="
                storeSettlementInformation.settleType == 2 ||
                storeSettlementInformation.settleType == 3
              "
              class="settlement-account"
            >
              <div v-if="storeSettlementInformation.settleType == 2">
                收款账户姓名：{{
                  storeSettlementInformation.store
                    ? storeSettlementInformation.store.payeeIdName
                    : "-"
                }}
              </div>
              <div v-else>
                法人姓名：{{
                  storeSettlementInformation.store
                    ? storeSettlementInformation.store.saLegalName
                    : "-"
                }}
              </div>
              <div>
                支付宝账号：{{
                  storeSettlementInformation.store
                    ? storeSettlementInformation.settleType == 2
                      ? storeSettlementInformation.store.payeeAlipayAccount
                      : storeSettlementInformation.store
                          .alipaySubMerchantLogonId
                    : "-"
                }}
              </div>
            </div>
          </header>
          <div class="settlement-total">
            <span>门店结算金额</span
            ><strong
              >{{ money(storeSettlementInformation.settleAmount) }}元</strong
            >
          </div>
          <div class="settlement-body">
            <div class="amount-row purchase-row">
              <strong>商品进货价</strong
              ><strong>￥{{ money(storeSettlementInformation.costAmount) }}</strong>
            </div>
            <div class="payment-breakdown">
              <div class="amount-row">
                <strong
                  >首付金额
                  <el-tag
                    size="mini"
                    :type="
                      storeSettlementInformation.prepayPayeeType == 1
                        ? 'success'
                        : 'warning'
                    "
                    effect="dark"
                    >{{
                      storeSettlementInformation.prepayPayeeType == 1
                        ? "平台收取"
                        : "门店收取"
                    }}</el-tag
                  ></strong
                ><strong
                  >￥{{
                    money(storeSettlementInformation.prepayAmount)
                  }}</strong
                >
              </div>
              <div class="amount-row detail-row">
                <span>● 第一期租金</span
                ><span
                  >￥{{
                    money(storeSettlementInformation.prepayRentPrice)
                  }}</span
                >
              </div>
              <div class="amount-row detail-row">
                <span>● 押金</span
                ><span
                  >￥{{
                    money(storeSettlementInformation.prepayDepositPrice)
                  }}</span
                >
              </div>
              <div class="amount-row detail-row">
                <span>● 意外保</span
                ><span
                  >￥{{
                    money(storeSettlementInformation.insurancePrice)
                  }}</span
                >
              </div>
              <div class="amount-row lock-row">
                <strong
                  >监管锁费
                  <el-tag
                    size="mini"
                    :type="
                      storeSettlementInformation.lockPayeeType == 1
                        ? 'success'
                        : 'warning'
                    "
                    effect="dark"
                    >{{
                      storeSettlementInformation.lockPayeeType == 1
                        ? "平台收取"
                        : "门店收取"
                    }}</el-tag
                  ></strong
                ><strong
                  >￥{{ money(storeSettlementInformation.lockAmount) }}</strong
                >
              </div>
            </div>
            <div
              v-if="Number(storeSettlementInformation.rewardAmount) !== 0"
              class="payment-breakdown"
            >
              <div class="amount-row">
                <strong>其他货款</strong
                ><strong
                  >￥{{ money(storeSettlementInformation.rewardAmount) }}</strong
                >
              </div>
            </div>
            <div v-if="isJointOrder" class="payment-breakdown joint-breakdown">
              <h4 class="joint-title">联营结算明细</h4>
              <div class="amount-row extra-row">
                <span>供货方出资金额</span
                ><span
                  >￥{{
                    money(storeSettlementInformation.storeJointInvestPrice)
                  }}</span
                >
              </div>
              <div class="amount-row extra-row">
                <span>平台技术服务费</span
                ><span
                  >￥{{
                    money(storeSettlementInformation.storeJointServicePrice)
                  }}</span
                >
              </div>
            </div>
          </div>
        </section>
      </div>
      <div class="delivery-actions">
        <el-button size="small" @click="closePage">取消</el-button
        ><el-button
          type="primary"
          size="small"
          :disabled="blockTipStatus"
          @click="save"
          >提交发货</el-button
        >
      </div>
    </el-form>
  </div>
</template>

<script>
import {
  handleDeliveryStoreAPI,
  settlementAmountDetails,
  getServiceAreaTagTreeAPI,
  checkDeliveryRiskAPI,
} from "./api";
import FileUpload from "@/components/file-upload/index.vue";

export default {
  name: "DeliveryStore",
  components: { FileUpload },
  props: {
    blockTipStatus: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      storeSettlementInformation: {},
      row: {},
      rules: [{ required: true, message: "该项不能为空", trigger: "blur" }],
      formData: {
        orderNo: this.$route.params.id,
        serialNo: "",
        lockCode: "",
        lockType: "zhunfu5",
        receiveImageList: [],
        holdingReceiveImage: "",
        incomeImage: "",
        serviceAreaTagCode: "",
        remark: "",
      },
      serviceAreaTagList: [],
    };
  },

  computed: {
    /** 订单模式 3-联营订单 */
    isJointOrder() {
      return this.storeSettlementInformation.orderMode === 3;
    },
  },
  watch: {
    "formData.serialNo"(val) {
      if (val && /\s/.test(val)) {
        this.formData.serialNo = val.replace(/\s/g, "");
      }
    },
  },
  mounted() {
    this.getSettlementAmountDetails(); //获取门店结算金额明细
    this.getServiceAreaTagList();
  },

  methods: {
    money(value) {
      return value == null ? "-" : value;
    },
    async getSettlementAmountDetails() {
      this.storeSettlementInformation = await settlementAmountDetails({
        orderNo: this.$route.params.id,
      });
    },
    async getServiceAreaTagList() {
      const tagList = await getServiceAreaTagTreeAPI();
      if (tagList.length > 0) {
        this.serviceAreaTagList = tagList[0];
      }
    },
    handleServiceAreaTagToggle(tagCode) {
      this.formData.serviceAreaTagCode =
        this.formData.serviceAreaTagCode === tagCode ? "" : tagCode;
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          checkDeliveryRiskAPI({ orderNo: this.$route.params.id }).then(
            (res) => {
              if (!res.wxcpKfStatus) {
                this.$confirm(
                  "该客户尚未添加客服，是否继续发货？",
                  "发货提醒",
                  {
                    confirmButtonText: "确认",
                    cancelButtonText: "取消",
                    type: "warning",
                  },
                )
                  .then(() => {
                    this.submitDelivery(this.formData);
                  })
                  .catch(() => {});
              } else {
                this.submitDelivery(this.formData);
              }
            },
          );
        }
      });
    },
    async submitDelivery(data) {
      try {
        await handleDeliveryStoreAPI(data);
        this.$message.success("自提成功");
        setTimeout(() => {
          this.closePage();
        }, 1000);
      } catch (error) {
        if (error?.data?.code == 1300002) {
          this.$confirm("该客户已租凭过此设备，是否继续发货？", "发货提醒", {
            confirmButtonText: "确认",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.submitDelivery({ ...data, secondConfirmed: true });
            })
            .catch(() => {});
        }
      }
    },
    emitAwindow() {
      //window.opener 获取父页面的window元素
      //判断A窗口有没有window.opener和getBpageList是不是个方法
      if (window.opener && window.opener.getBpageList) {
        window.opener.getBpageList();
      } else {
        //window.opener.frames[0] 获取到的window对象
        window.opener.frames[0].getBpageList();
      }
    },
    closePage() {
      this.emitAwindow();
      window.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.delivery-store {
  display: flex;
  flex: 1;
  width: 100%;
  color: #303133;
  font-size: 14px;
}
.delivery-form {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
}
.delivery-columns {
  margin-bottom: 30px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 30px;
  align-items: stretch;
}
.entry-card,
.settlement-card {
  min-width: 0;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  overflow: hidden;
}
.entry-card {
  padding: 16px 20px 20px;
}
.serial-no-input {
  width: 360px;
  max-width: 100%;
}
.panel-title {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0 0 20px;
  font-size: 14px;
  font-weight: 600;
}
.panel-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #409eff;
}
small {
  font-size: 12px;
  color: #909399;
  font-weight: 400;
  margin-left: 4px;
}
.delivery-form ::v-deep .el-form-item__label {
  padding: 0 0 6px;
  line-height: 22px;
  font-size: 14px;
  color: #303133;
}
.delivery-form ::v-deep .el-form-item {
  margin-bottom: 18px;
}
.auxiliary-heading {
  margin-bottom: 8px;
  font-weight: 600;
}
.auxiliary-uploads {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}
.auxiliary-uploads ::v-deep .el-form-item {
  margin: 0;
}
.upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 148px;
  height: 148px;
  font-size: 12px;
  line-height: 18px;
  color: #606266;
  i {
    font-size: 26px;
    color: #303133;
  }
}
.upload-tip {
  margin: 12px 0 16px;
  color: #e6a23c;
  font-size: 12px;
  line-height: 20px;
}
.choice-columns {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  margin-top: 24px;
  margin-bottom: 12px;
  ::v-deep .el-form-item__label {
    padding-bottom: 14px;
  }
}
.tag-option {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.tag-option ::v-deep {
  .el-radio-button:focus:not(.is-focus):not(:active):not(.is-disabled) {
    box-shadow: none;
  }
  .el-radio-button:focus-visible {
    outline: 2px solid #409eff;
    outline-offset: 3px;
    border-radius: 20px;
  }
  .el-radio-button__inner {
    border: 1px solid #dcdfe6;
    border-radius: 20px;
    padding: 10px 18px;
    font-size: 14px;
    box-shadow: none;
  }
  .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    color: #fff;
    background: #409eff;
    border-color: #409eff;
    box-shadow: none;
  }
}
.remark-field {
  padding-top: 8px;
  margin-bottom: 0 !important;
}
.settlement-header {
  padding: 16px 20px 24px;
  background: #777;
  color: #fff;
  .panel-title {
    margin-bottom: 20px;
    color: #fff;
  }
  .panel-dot {
    background: #fff;
  }
}
.settlement-overview {
  position: relative;
  padding-right: 120px;
}
.settlement-type-tag {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 96px;
  height: 36px;
  padding: 0 14px;
  font-size: 14px;
}
.settlement-store {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  strong {
    font-size: 18px;
  }
}
.settlement-total {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 24px 20px 20px;
  border-bottom: 1px dashed #dcdfe6;
  > span {
    color: #909399;
  }
  strong {
    font-size: 28px;
    color: #d9362b;
  }
}
.settlement-body {
  padding: 0 20px 20px;
}
.amount-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  padding: 12px 0;
  > :last-child {
    flex-shrink: 0;
  }
}
.purchase-row {
  padding: 20px 4px;
  border-bottom: 1px dashed #dcdfe6;
}
.payment-breakdown {
  padding: 16px;
  margin-top: 18px;
  border: 1px dashed #a8abb2;
  border-radius: 8px;
  .el-tag {
    margin-left: 6px;
  }
}
.detail-row {
  padding: 8px 0;
  font-size: 13px;
}
.lock-row {
  margin-top: 16px;
  padding-top: 20px;
  border-top: 1px dashed #dcdfe6;
}
.settlement-account {
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.25);
  color: #fff;
  font-size: 13px;
  line-height: 24px;
  overflow-wrap: anywhere;
}
.extra-row {
  border-bottom: 1px dashed #ebeef5;
}
.joint-breakdown .extra-row:last-child {
  border-bottom: 0;
}
.joint-title {
  margin: 0 0 8px;
  padding-bottom: 12px;
  border-bottom: 1px dashed #dcdfe6;
  color: #303133;
  font-size: 14px;
  font-weight: 600;
}
.delivery-actions {
  position: sticky;
  bottom: -24px;
  z-index: 20;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin: auto -24px -24px;
  padding: 20px 24px;
  background: #fff;
  border-top: 1px solid #ebeef5;
  box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.04);
  .el-button + .el-button {
    margin-left: 0;
  }
}
@media (max-width: 1000px) {
  .delivery-columns {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 600px) {
  .choice-columns {
    grid-template-columns: 1fr;
  }
}
</style>
